import { environment } from '../../../../../environments/environment';
// import * as angular from 'angular';

(function () {
  'use strict';

  angular.module('app').service('ProviderContactService', ProviderContactService);

  ProviderContactService.$inject = [
    'RestResource',
    '$translate',
    '$filter',
    'UtilService',
    'ProviderContactModalService',
  ];

  function ProviderContactService(
    RestResource,
    $translate,
    $filter,
    UtilService,
    ProviderContactModalService
  ) {
    var utils = new UtilService(this);

    $translate = $filter('translate');

    var apiUrl = environment.apiEndpoint + 'providers';

    var service = {
      getProviderContacts: getProviderContacts,
      openProviderContactModal: openProviderContactModal,
      saveProviderContact: saveProviderContact,
      changeProviderContactStatus: changeProviderContactStatus,
      changeProviderContactDefault: changeProviderContactDefault,
      deleteProviderContact: deleteProviderContact,
    };

    return service;

    function getProviderContacts(providerId, filterCriteria) {
      var url = apiUrl + '/' + providerId + '/provider_contacts';
      return RestResource.request(
        'get',
        url,
        filterCriteria,
        function (response) {
          return response.data;
        },
        {}
      );
    }

    function openProviderContactModal(providerContact, provider, mode, fast, successCallback) {
      var originalItem = angular.copy(providerContact);

      var confirmCallback = function (response) {
        if (providerContact.id) {
          providerContact.name = response.name;
          providerContact.last_name = response.last_name;
          providerContact.position = response.position;
          providerContact.email = response.email;
          providerContact.phone_number = response.phone_number;
          providerContact.phone_extension = response.phone_extension;
          providerContact.mobile_number = response.mobile_number;

          utils.itemListChanged(response.id);
        }

        return successCallback(response);
      };

      ProviderContactModalService.openProviderContact(
        originalItem,
        provider,
        mode,
        fast,
        confirmCallback
      );
    }

    function saveProviderContact(providerContact, providerId) {
      var itemAddedMsg = $translate('CONTACT_ADDED');
      var itemModifiedMsg = $translate('CONTACT_MODIFIED');

      var url = apiUrl + '/' + providerId + '/provider_contacts';

      var method = providerContact.id ? 'put' : 'post';
      url = providerContact.id ? url + '/' + providerContact.id : url;

      function success(response) {
        var msg = providerContact.id ? itemModifiedMsg : itemAddedMsg;
        utils._successMsg(msg);

        return {
          status: true,
          response: response.data,
        };
      }

      function failure(response) {
        return {
          status: false,
          response: response.data,
        };
      }

      return RestResource.request(
        method,
        url,
        { provider_contact: providerContact },
        success,
        failure
      );
    }

    function changeProviderContactStatus(providerContact, providerId) {
      var url = apiUrl + '/' + providerId + '/provider_contacts/' + providerContact.id;

      var params = { title: null, successMsg: null };
      if (providerContact.status === 'active') {
        params.title = 'DEACTIVATE_CONTACT';
        params.successMsg = 'CONTACT_MODIFIED';
      }

      utils.changeItemStatus(url, providerContact, params);
    }

    function changeProviderContactDefault(providerContact, successCallback) {
      var url =
        apiUrl + '/' + providerContact.provider_id + '/provider_contacts/' + providerContact.id;

      var params = {
        provider_contact: {
          is_default: true,
        },
        set_default: true,
      };

      function success() {
        var msg = $translate('DEFAULT_CONTACT_CHANGED');
        utils._successMsg(msg);

        return successCallback();
      }
      function failure() {}

      return RestResource.request('put', url, params, success, failure);
    }

    function deleteProviderContact(providerContact, providerId, successCallback, index) {
      var params = {
        title: 'DELETE_CONTACT',
        reason: 'DELETE_ITEM_REASON',
        successMsg: 'CONTACT_DELETED',
      };

      var url = apiUrl + '/' + providerId + '/provider_contacts/' + providerContact.id;
      utils.deleteItem(url, successCallback, params, index);
    }
  }
})();
